import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
//
import rootReducer from './rootReducer';
import { businessService } from './services/businessService';
import { clientService } from './services/clientService';
import { commonService } from './services/commonService';
import { companyService } from './services/companyService';
import { contractService } from './services/contractService';
import { incomeService } from './services/incomeService';
import { permissionService } from './services/permissionService';
import { quotationService } from './services/quotationService';
import { roleService } from './services/roleService';
import { serviceService } from './services/serviceService';
import { supplierService } from './services/supplierService';
import { userService } from './services/userService';

// ----------------------------------------------------------------------

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      businessService.middleware,
      clientService.middleware,
      commonService.middleware,
      companyService.middleware,
      contractService.middleware,
      incomeService.middleware,
      permissionService.middleware,
      quotationService.middleware,
      roleService.middleware,
      serviceService.middleware,
      supplierService.middleware,
      userService.middleware
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
